import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Button from '../CustomButton/Button';
import ToastNotification from '../Notification/ToastNotification';
import axiosInstance from '../../utils/axiosInstanse';
import host from "../../host";
import './style.css';

function UserActivationCard({ user }) {
  const [currentUser, setCurrentUser] = useState(user);
  const [sending, setSending] = useState(false);
  const [notification, setNotification] = useState({
    show: false,
    message: '',
    type: 'success'
  });

  const formatPhoneNumber = (phone) => {
    if (!phone) return 'Не указан';
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length === 11) {
      return `+${cleaned[0]} (${cleaned.substring(1, 4)}) ${cleaned.substring(4, 7)}-${cleaned.substring(7, 9)}-${cleaned.substring(9)}`;
    }
    return phone;
  };

  const handleSubmit = async (status) => {
    if (sending) return;
    try {
      setSending(true);
      const response = await axiosInstance.post(`${host}api/activate/user_activate/`, {
        id: currentUser.id,
        status: status
      });

      if (response.status === 200) {
        setCurrentUser(prev => ({
          ...prev,
          status: status,
          is_active: status
        }));
        setNotification({
          show: true,
          message: status ? 'Пользователь активирован' : 'Пользователь деактивирован',
          type: 'success'
        });
        setTimeout(() => {
          setNotification(prev => ({ ...prev, show: false }));
        }, 4000);
      }
      setSending(false);
    } catch (error) {
      setNotification({
        show: true,
        message: 'Ошибка при изменении статуса',
        type: 'error'
      });
      setSending(false);
    }
  };

  const getCardMod = () => {
    if (currentUser.status === false || currentUser.is_active === false) {
      return 'au-card--inactive';
    } else if (currentUser.status === true) {
      return 'au-card--active';
    }
    return 'au-card--pending';
  };

  const handleCloseNotification = () => {
    setNotification(prev => ({ ...prev, show: false }));
  };

  const cardMod = getCardMod();
  const isActive = currentUser.status === true;
  const isInactive = currentUser.status === false || currentUser.is_active === false;

  return (
    <motion.div
      initial={{ opacity: 0, y: -16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.12 }}
      style={{ width: '100%' }}
    >
      <div className={`au-card ${cardMod}`}>
        {/* Header */}
        <div className="au-card-header">
          <span className={`au-status-text ${
            isActive ? 'au-status-text--active' :
            isInactive ? 'au-status-text--inactive' :
            'au-status-text--pending'
          }`}>
            Статус: {isActive ? 'Активен' : isInactive ? 'Неактивен' : 'На рассмотрении'}
          </span>
        </div>

        {/* Body */}
        <div className="au-card-body">
          <div className="au-info-row">
            <span className="au-info-label">ФИО:</span>
            <span className="au-info-value">{currentUser.full_name || currentUser.fio || 'Не указано'}</span>
          </div>

          <div className="au-info-row" style={{ justifyContent: 'center' }}>
            <span className="au-info-label">Табельный номер:</span>
            <span className="au-tab-badge">{currentUser.tab_num || 'Не указан'}</span>
          </div>

          <div className="au-info-row">
            <span className="au-info-label">Телефон:</span>
            <span className="au-info-value">{formatPhoneNumber(currentUser.phone)}</span>
          </div>

          {currentUser.created_at && (
            <div className="au-info-row">
              <span className="au-info-label">Заявка от:</span>
              <span className="au-info-value">
                {new Date(currentUser.created_at).toLocaleString('ru-RU', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit'
                })}
              </span>
            </div>
          )}
        </div>

        {/* Actions */}
        <div className="au-actions">
          <motion.button
            className="au-btn au-btn--activate"
            onClick={() => handleSubmit(true)}
            disabled={isActive || sending}
            whileTap={{ scale: 0.97 }}
          >
            {sending ? (
              <span className="au-spinner" />
            ) : isActive ? (
              'Активен ✓'
            ) : (
              'Активировать'
            )}
          </motion.button>

          <motion.button
            className="au-btn au-btn--reject"
            onClick={() => handleSubmit(false)}
            disabled={isInactive || sending}
            whileTap={{ scale: 0.97 }}
          >
            {sending ? (
              <span className="au-spinner" />
            ) : isInactive ? (
              'Неактивен ✗'
            ) : (
              'Отклонить'
            )}
          </motion.button>
        </div>
      </div>

      {notification.show && (
        <ToastNotification
          show={notification.show}
          message={notification.message}
          onClose={handleCloseNotification}
          type={notification.type}
        />
      )}
    </motion.div>
  );
}

export default UserActivationCard;